export const options = {
  TABLESIDE: "active",
  TAKEAWAY: "",
  CURRENT_ORDERS: "",
};
export const handleClick = (setFunction, value) => {
  const newObject = {
    TABLESIDE: "",
    TAKEAWAY: "",
    CURRENT_ORDERS: "",
  };
  setFunction({ ...newObject, [value]: "active" });
};
